/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSavingResourceDetails {
    getFixupPrototypeFunction() { return CostSavingResourceDetails.fixupPrototype; }

    static newInstance(model: Partial<CostSavingResourceDetails>): CostSavingResourceDetails {
        let obj = Object.assign(new CostSavingResourceDetails(), model);
        CostSavingResourceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSavingResourceDetails>): CostSavingResourceDetails {
        if (!model) return null;
        return CostSavingResourceDetails.newInstance(<CostSavingResourceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSavingResourceDetails) {
        if (!obj) return;

        models.CostSavingResourceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSavingResourceDetails): boolean {
        Object.setPrototypeOf(obj, CostSavingResourceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.saving_per_day === undefined) {
            this.saving_per_day = 0;
        }
        if (this.saving_per_month === undefined) {
            this.saving_per_month = 0;
        }
        if (this.saving_per_year === undefined) {
            this.saving_per_year = 0;
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * Cost saving per day by resource
     */
    saving_per_day: number;

    /**
     * Cost saving per day by resource
     */
    saving_per_month: number;

    /**
     * Cost saving per year by resource
     */
    saving_per_year: number;

    /**
     * Recently Updated time
     */
    updated_at: Date;

}
